<mat-list role="list">
  @for (update of recalculateEntry.FieldUpdates; track update) {
    <mat-list-item role="listitem"><span
      class="bold-text">{{ update.FieldName }}</span> from <span
      class="bold-text">{{ update.InitialValue }}</span> to <span class="bold-text">{{ update.UpdatedValue }}</span>
    </mat-list-item>
  }
</mat-list>
